import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/global.css';

import LandingPage from './pages/LandingPage';

/**
 * Uma página só, e por isso sem roteador: o admin e o cardápio precisam de
 * `react-router` porque têm telas; aqui tudo é âncora dentro do mesmo
 * documento, e o navegador já sabe fazer isso sozinho.
 *
 * O `global.css` entra DEPOIS do Bootstrap de propósito — é ele que sobrescreve
 * o que vem de fábrica com os tokens da marca.
 */
function App() {
  return <LandingPage />;
}

export default App;
